module.exports = __webpack_public_path__ + "static/media/1.3a92a11d.jpg";